import React from "react";
import { FloatingBar } from "../../floating-bar";
import "./top-menu-overflow-bar.css";

export function TopMenuOverflowBar({
	show,
	children,
}: {
	show: boolean;
	children: React.ReactNode;
}) {
	if (!show) return null;

	return (
		<FloatingBar.Bar className="top-menu-bar top-menu-overflow-bar">{children}</FloatingBar.Bar>
	);
}
